import { render, staticRenderFns } from "./EditScheduledMessage.vue?vue&type=template&id=6c323798&scoped=true&"
import script from "./EditScheduledMessage.vue?vue&type=script&lang=js&"
export * from "./EditScheduledMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditScheduledMessage.vue?vue&type=style&index=0&id=6c323798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c323798",
  null
  
)

export default component.exports